package nl.astraeus.wiki.view

import kotlinx.browser.window
import kotlinx.html.div
import kotlinx.html.h1
import kotlinx.html.hr
import nl.astraeus.css.properties.prc
import nl.astraeus.komp.HtmlBuilder
import nl.astraeus.komp.Komponent
import nl.astraeus.markdown.parser.markdown
import nl.astraeus.wiki.WikiData
import nl.astraeus.wiki.components.MarkdownRenderer
import nl.astraeus.wiki.css.Css.defineCss
import nl.astraeus.wiki.css.CssName
import nl.astraeus.wiki.messages.GetPageMessage
import nl.astraeus.wiki.messages.MessageType
import nl.astraeus.wiki.messages.PageMessage
import nl.astraeus.wiki.service.ResourceService
import nl.astraeus.wiki.ws.WebsocketConnection

data class Page(
  val title: String,
  var content: String,
)

class AllPages : Komponent(), CssName {
  object Height100Css : CssName

  init {
    defineCss {
      select(Height100Css.cls()) {
        height(100.prc)
      }
    }
  }

  var pages = Array(0) { Page("", "") }

  fun updatePages() {
    val count = WikiData.pageList.size
    var loaded = 0

    pages = Array(count) { index ->
      Page(WikiData.pageList[index].title, "")
    }

    for ((index, page) in WikiData.pageList.withIndex()) {
      WebsocketConnection.send(GetPageMessage(page.id)) {
        check(it.getMessageType() == MessageType.PAGE_MESSAGE) {
          "Expected page message, got ${it.getMessageType()} instead"
        }

        val message = PageMessage(it.message)

        pages[index].content = message.getBody()
        loaded++
        if (loaded == count) {
          requestUpdate()
          window.setTimeout({
            printWhenDoneLoading()
          }, 25)
        }
      }
    }
  }

  private fun printWhenDoneLoading() {
    if (!ResourceService.isLoading()) {
      window.print()
    } else {
      window.setTimeout({
        printWhenDoneLoading()
      }, 10)
    }
  }

  override fun HtmlBuilder.render() {
    div(Height100Css.name) {
      for ((index, page) in pages.withIndex()) {
        if (index > 0) {
          div("page-break")
        }
        div {
          h1 {
            +page.title
          }
        }
        hr {}
        include(
          MarkdownRenderer(
            markdown(page.content)
          )
        )
      }
    }
  }
}
